import { ExpPromoteMobileAppBanner } from './helpers';
import { useABTesting } from '@/hooks/abTesting';
import { useCommonStore } from '@/store';

export const useIsPromoteMobileAppBanner = () => {
  const isAuthenticated = useCommonStore.use.isAuthenticated();

  const isPromoteMobileAppBanner =
    useABTesting('exp_lu_promote_mobile_app_top_banner', {
      defaultVersion: ExpPromoteMobileAppBanner.A,
      versions: [
        { name: ExpPromoteMobileAppBanner.A, probability: 50 },
        { name: ExpPromoteMobileAppBanner.B, probability: 50 },
      ],
      turnOffTest: !isAuthenticated,
    }) === ExpPromoteMobileAppBanner.B;

  return isPromoteMobileAppBanner;
};
